// extracted by mini-css-extract-plugin
export var linkText = "_nt-0";